import React from 'react';
import { Link } from 'react-router-dom';
import AdSlot from '../AdSlot';
import themesData from '../../data/themes.json';

const ThemeSidebar: React.FC = () => {
  const categories = [
    { label: 'All Themes', value: 'all' },
    { label: 'Blogger Themes', value: 'blogger' },
    { label: 'WordPress Themes', value: 'wordpress' },
  ];

  const featuredThemes = themesData.filter((theme: any) => theme.featured).slice(0, 5);

  return (
    <aside className="space-y-6 !min-h-full" style={{ height: "100%" }}>

      {/* Need Help */}
      <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-xl border border-sky-200 p-6">
        <h3 className="font-semibold text-gray-900 mb-2">Need Custom Theme?</h3>
        <p className="text-sm text-gray-600 mb-4">
          Get a professionally designed custom theme tailored to your needs.
        </p>
        <Link to="/hire">
          <button className="w-full px-4 py-2 bg-gradient-to-r from-sky-500 to-blue-600 text-white rounded-lg text-sm font-medium hover:shadow-lg transition-all duration-300">
            Hire Us
          </button>
        </Link>
      </div>

      

{/* 
      <AdSlot slot="sidebar" /> */}

      {/* Featured Themes */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Featured Themes</h3>
        <div className="space-y-3">
          {featuredThemes.map((theme: any) => (
            <Link
              key={theme.id}
              to={`/theme/${theme.slug}`}
              className="block group"
            >
              <img
                src={theme.thumbnail || `https://placehold.co/600x400/dee3f8/303b5c?text=${encodeURIComponent(theme.title)}`}
                alt={theme.title}
                className="w-full aspect-16-9 object-cover rounded-lg mb-2"
              />
              <h4 className="text-sm font-medium text-gray-900 group-hover:text-sky-500 transition-colors line-clamp-2">
                {theme.title}
              </h4>
              <p className="text-sm font-semibold text-sky-500 mt-1">${theme.price}</p>
            </Link>
          ))}
        </div>
      </div>


      {/* Categories Filter */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Theme Categories</h3>
        <div className="space-y-2">
          {categories.map((category) => (
            <Link
              key={category.value}
              to={`/templates?category=${category.value}`}
              className="block px-3 py-2 text-sm text-gray-700 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              {category.label}
            </Link>
          ))}
        </div>
      </div>

      
      <AdSlot slot="sidebar" className="my-2 sticky top-[70px]"/>

    </aside>
  );
};

export default ThemeSidebar;